/**
 * Hech qanday tanilgan super app yoki Telegram muhitida emas. Mahalliy ishlanma
 * uchun `localhost` da Click login dev fallback sifatida ishlaydi. Production
 * domenida bu host faollashsa, foydalanuvchiga `UnsupportedHostError` tashlanadi
 * va `main.tsx` "Telegram orqali oching" tipidagi error sahifa ko'rsatadi.
 */

import type { HostAdapter, LoginResponse } from "./types";
import { UnsupportedHostError } from "./types";
import { NotTelegramEnvironmentError } from "./telegramHost";
import { clickHost } from "./clickHost";

const DEV_LOCAL_HOSTNAMES = new Set(["localhost", "127.0.0.1"]);

function isDevLocal(): boolean {
  if (typeof window === "undefined") return false;
  return import.meta.env.DEV && DEV_LOCAL_HOSTNAMES.has(window.location.hostname);
}

export const webHost: HostAdapter = {
  id: "web",
  brandId: "default",

  /** Catch-all — registry oxirida turishi shart */
  match() {
    return true;
  },

  async login(): Promise<LoginResponse> {
    if (isDevLocal()) {
      // Dev convenience: localhost da Click flow ni test qilish uchun
      return clickHost.login();
    }
    // Production: aniqlanmagan domen → Telegram orqali ochish kerakligini bildiramiz
    throw new NotTelegramEnvironmentError();
  },
};

export { UnsupportedHostError };
